import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Tracking = () => {
  const location = useLocation();

  useEffect(() => {   
    if (typeof dataLayer === 'undefined') {
        return;
    }
    dataLayer.push({
        event: 'configurator_page',
        page: location.hash.substring(1)
    });
  }, [location]);

  return null;
};

export default Tracking;
